import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import InfiniteScroll from 'react-infinite-scroll-component';
import Sticky from 'react-sticky-el';
import { PAGE_NAMES } from 'appenv';

import CircularLoadingIndicator from 'components/indicators/CircularLoadingIndicator';
import SearchResultContainer from './SearchResultContainer';

const RootContainer = styled.div`
  width: 100%;
`;

const StyledSectionTitle = styled.div`
  font-weight: bold;
  font-size: 14px;
  line-height: 14px;
  color: #999;
  padding: 16px 0;
  background-color: #F0F2F5;
`;

const AllSearchResultContainer = ({
  showResult,
  exhibitors,
  webinars,
  participants,
  fetchMore,
  hasNextPage,
  getScrollParentRef,
}) => (
  <RootContainer>
    {
      showResult && (
        <InfiniteScroll
          dataLength={exhibitors.length + webinars.length + participants.length}
          next={fetchMore}
          hasMore={hasNextPage}
          loader={<CircularLoadingIndicator key="loading-indicator" size={32} />}
          scrollableTarget={getScrollParentRef()}
          scrollThreshold={1}
        >
          <Sticky
            scrollElement={getScrollParentRef()}
            stickyStyle={{ zIndex: 10 }}
          >
            <StyledSectionTitle>
              {PAGE_NAMES.exhibitors}
            </StyledSectionTitle>
          </Sticky>
          <SearchResultContainer
            type="exhibitor"
            results={exhibitors}
          />
          <Sticky
            scrollElement={getScrollParentRef()}
            stickyStyle={{ zIndex: 10 }}
          >
            <StyledSectionTitle>
              {PAGE_NAMES.webinar}
            </StyledSectionTitle>
          </Sticky>
          <SearchResultContainer
            type="webinar"
            results={webinars}
          />
          <Sticky
            scrollElement={getScrollParentRef()}
            stickyStyle={{ zIndex: 10 }}
          >
            <StyledSectionTitle>
              {PAGE_NAMES.participant}
            </StyledSectionTitle>
          </Sticky>
          <SearchResultContainer
            type="participant"
            results={participants}
          />
        </InfiniteScroll>
      )
    }
  </RootContainer>
);

AllSearchResultContainer.propTypes = {
  showResult: PropTypes.bool,
  exhibitors: PropTypes.arrayOf(PropTypes.shape()),
  webinars: PropTypes.arrayOf(PropTypes.shape()),
  participants: PropTypes.arrayOf(PropTypes.shape()),
  fetchMore: PropTypes.func,
  hasNextPage: PropTypes.bool,
  getScrollParentRef: PropTypes.func,
};

AllSearchResultContainer.defaultProps = {
  showResult: false,
  exhibitors: [],
  webinars: [],
  participants: [],
  fetchMore: () => {},
  hasNextPage: false,
  getScrollParentRef: () => {},
};

export default AllSearchResultContainer;
